import axios from "axios";
import Cookies from "js-cookie";
import PropTypes from "prop-types";
import { createContext, useContext, useEffect, useState } from "react";

export const MODE_DEVELOPER = "developer";
export const MODE_ORGANIZER = "organizer";

const noop = () => undefined;

const ModeContext = createContext({
  mode: MODE_DEVELOPER,
  loading: true,
  setMode: noop,
  toggleMode: noop,
});

export const useMode = () => useContext(ModeContext);

export const ModeProvider = ({ children }) => {
  const [mode, setModeState] = useState(MODE_DEVELOPER);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    axios
      .get("/api/league/mode/", { withCredentials: true })
      .then((res) => {
        if (!cancelled && res.data && res.data.mode)
          setModeState(res.data.mode);
        return null;
      })
      .catch(() => {
        // Unauthenticated or league unavailable: keep the default mode.
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const setMode = async (next) => {
    const res = await axios.post(
      "/api/league/mode/switch/",
      { mode: next },
      {
        headers: { "X-CSRFTOKEN": Cookies.get("csrftoken") },
        withCredentials: true,
      },
    );
    setModeState(res.data.mode);
    return res.data.mode;
  };

  const toggleMode = () =>
    setMode(mode === MODE_ORGANIZER ? MODE_DEVELOPER : MODE_ORGANIZER);

  return (
    <ModeContext.Provider value={{ mode, loading, setMode, toggleMode }}>
      {children}
    </ModeContext.Provider>
  );
};

ModeProvider.propTypes = {
  children: PropTypes.node,
};
